import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import SettingsIcon from '@mui/icons-material/Settings';
import useStore from '../../../Store/Store';
import { capitalize, isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';
const Progress = ({ total, value }) => {
  return (
    <CircularProgressbar
      value={value}
      maxValue={total}
      circleRatio={0.8}
      styles={{
        root: {},
        path: {
          stroke: `#8cd03b`,
          strokeLinecap: 'butt',
          transition: 'stroke-dashoffset 0.5s ease 0s',
          transform: 'rotate(0.6turn)',
          transformOrigin: 'center center',
          strokeWidth: 4,
        },
        trail: {
          stroke: 'grey',
          strokeLinecap: 'butt',
          transform: 'rotate(0.60turn)',
          transformOrigin: 'center center',
          strokeWidth: 4,
          strokeOpacity: '0.3',
        },
      }}
    />
  );
};

const HealthOverviewCard = () => {
  const navigate = useNavigate();
  const width = useStore((state) => state.screenWidth);
  const deviceActivities = useStore((state) => state.deviceActivities);
  const user = useStore((state) => state.user);
  const goals = user?.goal?.daily?.at(-1)?.value || 30;

  return (
    <div className="frame-5e" style={{ height: width > 900 ? '352px' : 'auto' }}>
      <div className="frame-5f" style={{ display: width > 545 ? 'flex' : 'block' }}>
        <span className="health-overview">Health overview</span>
        <div className="frame-60">
          <button className="button-61" onClick={() => navigate('/health-overview')}>
            <span className="see-more-details">See more details</span>
            <div className="arrow-up-right-62">
              <ArrowOutwardIcon style={{ color: '#fff' }} fontSize="15px" />
            </div>
          </button>
          <div className="button-64">
            <div className="gear-six">
              <SettingsIcon fontSize="15px" />
            </div>
          </div>
        </div>
      </div>
      <div className="frame-66" style={{ display: width > 900 ? 'flex' : 'block' }}>
        {isEmpty(deviceActivities) &&
          [
            {
              key: 'minutes',
              value: 0,
            },
            {
              key: 'distance',
              value: 0,
            },
            {
              key: 'feet',
              value: 0,
            },
          ].map((item, idx) => (
            <div className="frame-67 top-margin-card" key={idx}>
              <div className="frame-68">
                <Progress total={goals} value={item.value} />
                <button className="tags-69">
                  <span className="daily-activity-goal">{capitalize(item.key)}</span>
                </button>
                <div className="group-6a" />
                <div className="frame-6b">
                  <div className="slash">
                    <span className="number-10">{item.value}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}

        {!isEmpty(deviceActivities) &&
          Object.entries(deviceActivities || {}).map(([key, value], idx) => (
            <div className="frame-67 top-margin-card" key={idx}>
              <div className="frame-68">
                <Progress total={goals} value={value} />
                <button className="tags-69">
                  <span className="daily-activity-goal">{key === 'activityMins' ? 'Activities' : capitalize(key)}</span>
                </button>
                <div className="group-6a" />
                <div className="frame-6b">
                  <div className="slash">
                    <span className="number-10">{value}</span>
                    {key === 'activityMins' && <span className="slash-6c">/{goals}</span>}
                  </div>
                  <span className="minutes">
                    {key === 'activityMins' ? 'minutes' : key === 'distance' ? 'feet' : key}
                  </span>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default HealthOverviewCard;
